module.exports = __webpack_public_path__ + "static/img/cheng.37ee3c74.png";